$(function () {
    const $form = $('[data-stock-action-form][data-operation="transfer"]');
    if (!$form.length) return;

    const $balance = $form.find('[data-stock-balance]');
    const $group = $form.find('[data-stock-units-group]');
    const $list = $form.find('[data-transfer-unit-list]');
    const $search = $form.find('[data-transfer-unit-search]');
    const $count = $form.find('[data-transfer-selected-count]');
    const $quantity = $form.find('[name="quantity"]');
    const $submit = $form.find('[data-transfer-submit]');
    const $modal = $('[data-transfer-history-modal]');
    const $history = $modal.find('[data-transfer-history-content]');
    const prefill = (($form.data('prefillUnitIds') || '') + '').split(',').filter(Boolean).map(String);
    let units = [];
    let historyRequestId = 0;
    let applyPrefill = true;
    let selectedIds = new Set(prefill);
    let readySource = '';
    let searchQuery = '';

    const groupNames = { recognized: 'Уже учтена', unrecognized: 'Ещё не учтена', zero: 'Подтверждённый ноль', unknown: 'Неизвестна' };
    const money = kopecks => (kopecks / 100).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽';
    const date = value => value ? new Date(value.slice(0, 10) + 'T00:00:00').toLocaleDateString('ru-RU') : '—';

    function updateCount() {
        const selected = $list.find('input[name="unit_ids[]"]:checked').length;
        if ($group.is(':visible')) $quantity.val(selected);
        $count.text('Выбрано: ' + selected);
        if ($group.is(':visible')) $submit.prop('disabled', !selected);
    }

    function showUnits() {
        const wanted = $balance.find(':selected');
        const itemId = Number(wanted.data('item-id'));
        const status = wanted.data('status');
        const matching = units.filter(unit => unit.item_id === itemId && unit.status === status);
        $list.empty();
        $search.val(itemId ? searchQuery : '');
        if (applyPrefill && matching.length) {
            selectedIds = new Set(prefill);
            applyPrefill = false;
        }
        if (!matching.length) {
            $group.hide();
            $quantity.attr('type', 'number').prop('required', true);
            $quantity.closest('.form-group').show();
            const available = Number(wanted.data('quantity')) || 1;
            $quantity.val(itemId && wanted.data('tracking-mode') === 'individual' ? 0 : Math.min(available, Math.max(1, Number($quantity.val()) || 1)));
            $submit.prop('disabled', !itemId || readySource !== String($form.find('[name="source_property_id"]').val()) || wanted.data('tracking-mode') === 'individual');
            return;
        }
        $quantity.attr('type', 'hidden').prop('required', false);
        $quantity.closest('.form-group').hide();
        $group.show();
        matching.forEach(unit => {
            const id = 'transfer-unit-' + unit.id;
            const $row = $('<div/>', { class: 'stock-transfer-unit', 'data-search': [unit.serial_number, unit.inventory_number].filter(Boolean).join(' ').toLowerCase() });
            const $main = $('<div/>', { class: 'd-flex align-items-start' });
            const $check = $('<input/>', { type: 'checkbox', id: id, name: 'unit_ids[]', value: unit.id, class: 'mr-2' }).prop('checked', selectedIds.has(String(unit.id)));
            const $label = $('<label/>', { for: id, class: 'flex-grow-1' });
            const numbers = [unit.serial_number && 'Серийный № ' + unit.serial_number, unit.inventory_number && 'Инвентарный № ' + unit.inventory_number].filter(Boolean);
            $('<strong/>').text(numbers.join(' · ') || 'Без серийного и инвентарного номеров').appendTo($label);
            if (!numbers.length) $('<span/>', { class: 'text-muted small ml-2' }).text('Внутр. #' + unit.id).appendTo($label);
            const $facts = $('<div/>', { class: 'small text-muted mt-1' });
            $facts.text('Добавлено: ' + date(unit.received_at) + ' · Партия #' + unit.lot_id
                + ' · Стоимость: ' + (unit.cost_state === 'unknown' || unit.valuation_status !== 'confirmed' ? 'неизвестна' : money(unit.original_cost_kopecks))
                + ' · Учтено: ' + (unit.cost_state === 'unknown' || unit.valuation_status !== 'confirmed' ? '—' : money(unit.recognized_cost_kopecks))
                + ' · Ещё не учтено: ' + (unit.cost_state === 'unknown' || unit.valuation_status !== 'confirmed' ? '—' : money(unit.unrecognized_cost_kopecks))
                + ' · Группа: ' + (groupNames[unit.recognition_group] || 'Требуется сверка')
                + ' · Гарантия: ' + date(unit.warranty_until)
                + (unit.maintenance_count ? ' · Обслуживаний: ' + unit.maintenance_count : '')
                + (unit.include_in_contract_inventory ? ' · В описи договора' : ''));
            $label.append($facts);
            $main.append($check, $label);
            $row.append($main);
            $('<button/>', { type: 'button', class: 'btn btn-link btn-sm p-0 mt-1', 'data-history-url': unit.history_url, text: 'История' }).appendTo($row);
            $list.append($row);
            $row.toggle(!searchQuery || ($row.attr('data-search') || '').includes(searchQuery));
        });
        updateCount();
    }

    $form.find('[name="source_property_id"]').on('change', function () {
        readySource = '';
        searchQuery = '';
        if (!applyPrefill) selectedIds = new Set();
        units = [];
        $list.empty();
        $group.hide();
        $quantity.attr('type', 'number').prop('required', true).closest('.form-group').show();
        $submit.prop('disabled', true);
        updateCount();
    });
    $form.on('stock:balances-cleared', function () {
        readySource = '';
        units = [];
        $list.empty();
        $group.hide();
        $submit.prop('disabled', true);
        $quantity.attr('type', 'number').prop('required', true).closest('.form-group').show();
    });
    if (!$balance.find(':selected').data('item-id')) $submit.prop('disabled', true);
    $form.on('stock:balances-loaded', function (_, loadedUnits) {
        readySource = String($form.find('[name="source_property_id"]').val());
        units = loadedUnits;
        showUnits();
    });
    $balance.on('change', function () {
        if (readySource !== String($form.find('[name="source_property_id"]').val())) return;
        searchQuery = '';
        if (!applyPrefill) selectedIds = new Set();
        showUnits();
    });
    $form.on('submit', function (event) {
        if ($group.is(':visible') && !$list.find('input[name="unit_ids[]"]:checked').length) {
            event.preventDefault();
            $search.trigger('focus');
        }
    });
    $list.on('change', 'input[name="unit_ids[]"]', function () {
        if ($(this).is(':checked')) selectedIds.add($(this).val());
        else selectedIds.delete($(this).val());
        updateCount();
    });
    $search.on('input', function () {
        searchQuery = $(this).val().trim().toLowerCase();
        $list.children().each(function () { $(this).toggle(!searchQuery || ($(this).attr('data-search') || '').includes(searchQuery)); });
    });

    function renderHistory(entries) {
        const $body = $('<div/>');
        if (!entries.length) return $body.text('Записей пока нет.');
        const $list = $('<ul/>', { class: 'list-unstyled mb-0' }).appendTo($body);
        entries.forEach(entry => {
            const $item = $('<li/>', { class: 'mb-2 pb-2 border-bottom' });
            $('<strong/>').text((entry.date || '—') + ' · ' + entry.label).appendTo($item);
            $('<div/>').text(entry.description || '').appendTo($item);
            if (entry.comment) $('<div/>', { class: 'small text-muted' }).text(entry.comment).appendTo($item);
            $list.append($item);
        });
        return $body;
    }

    $list.on('click', '[data-history-url]', function () {
        const url = $(this).attr('data-history-url');
        $history.text('Загрузка истории…');
        $modal.modal('show');
        const request = ++historyRequestId;
        $.getJSON(url).done(response => {
            if (request !== historyRequestId) return;
            $history.empty().append($('<h6/>').text('Последние два перемещения'), renderHistory(response.data.recent_transfers));
            const $more = $('<button/>', { type: 'button', class: 'btn btn-link p-0 mt-2', text: 'Вся история' });
            $more.on('click', function () {
                $history.empty();
                $history.append($('<h6/>', { class: 'mt-3' }).text('Вся история'), renderHistory(response.data.history));
            });
            $history.append($more);
        }).fail(() => { if (request === historyRequestId) $history.text('Не удалось загрузить историю. Попробуйте ещё раз.'); });
    });
    $modal.on('hidden.bs.modal', function () { historyRequestId++; });
});
